import { getIncomelist } from '@/api';
import { echartslineColor } from '@/tool/utils';
import { useEffect, useState } from 'react';
import CardHead from '../cardHead';
import Echarts from '../echarts/baseEcharts';
import PricePanel from '../pricePanel';
import './index.scss';


const types = ["USD", "ETH", "FIS"]

export default function Index() {

    const [updateTime, setUpdateTime] = useState<any>();
    const [yData, setYData] = useState<any>();
    const [echartList, setEchartList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [typesCount, setTypesCount] = useState<number>(0);

    useEffect(() => {
        setLoading(true)
        getIncomelist().then((res) => {
            if (res.data.status == "80000") {
                const data = res.data.data;
                setUpdateTime(data.info.updateTime);
                setTypesCount(data.info.typesCount);
                setYData(data.list[0].fees.yData);
                const list = data.list.map((item: any, index: number) => {
                    item.color = echartslineColor[index];
                    item.name = item.rsymbol;
                    item.data = item.fees.data.map((item: any) => {
                        return Number(item)
                    });
                    item.type = 'line';
                    return item
                })
                setEchartList(list)
            }
        }).finally(() => {
            setLoading(false)
        })
    }, [])


    return <div className="card-item-Container protocolIncomeContainer">
        <CardHead title="Protocol Income" tips={`StaFi Protocol charge rtokens as its protocol incomes, which mainly come from staking reward commission fee.`} />
        <div className='card-item-content'>
            <PricePanel text={`${typesCount} types of rToken`} color="blue" />
            <Echarts updateTime={updateTime} yData={yData} datas={echartList} loading={loading} />
        </div>
    </div>
}